export default {
	title: "There are no scheduled meetings.",
	createRecurrenceButton: "Add meeting",
};
